import store from '@/store'
import NProgress from 'nprogress'
import VisiteMedicaleAnnuelle from '@/views/mdt/visite-medicales/categories/visites-medicales-annuelles'
import router from '@/router'
export default {
  name: 'category-wrapper',
  components: {
    VisiteMedicaleAnnuelle
  },
  props: [],
  data () {
    return {

    }
  },
  async beforeRouteEnter(to, from, next){
    NProgress.start()
    await store.dispatch("checkIfVisiteMedicalesParamIsset").then(
     async ()=> {
        if(store.getters["parametrageVisiteMedicaleCheck"].verdict === false){
          console.log(store.getters["parametrageVisiteMedicaleCheck"].verdict)
          NProgress.done()
          router.push({path: '/visite-medicales/parametrages'})
        } else{
          await store.dispatch("getSingleSubCategoryVM",to.params.id).then(
            async ()  => {
             await  store.dispatch("getVisitesMedicales",store.getters["selectedSousCategoryVM"].id)
             next()
             NProgress.done()
            },
            error =>{
              error
              next()
              NProgress.done()
            }
          )
        }
      }
    )
    
 
  },
  computed: {
    subCategory(){
      return this.$store.getters["selectedSousCategoryVM"]
    },
    paramVisiteMedicaleIsset(){
      return this.$store.getters["parametrageVisiteMedicaleCheck"]
    }

  },
  mounted () {
    if(this.paramVisiteMedicaleIsset.verdict===false){
      this.$router.push({path: "/visite-medicales/parametrages"})
    }
  },
  methods: {

  }
}


